






































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {i18nInObjectList, i18nAllObject} from '@/utils/i18n';
import {htmlEncode} from '@/utils/formatUtils';
import {HtmlEncodeRenderer} from '@/utils/grid/rendererUtils';
import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {aHrefRenderer} from '@/utils/grid/rendererUtils';
import {writeExcel} from '@/utils/excel';
import {Mall, GetPopupsRequest, DisplayPopupSearchDateType, GetPopupsExcelRequest, DeletePopupsRequest, PutPopupsPopupNoDisplayStatusRequest} from 'supporter';

const mallModule = namespace('mall');
@Component({
  components: {CompSelectBox, PeriodDateCalendar, ItemTable}
})
export default class PopupList extends Vue {
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: string = '';
  private get mallList() {
    let list: any = [
      {
        value: '',
        name: this.$t('COMMON_ALL')
      }
    ];
    if (this.malls) {
      this.malls.forEach((mall) => {
        list.push({
          value: mall.mallNo.toString(),
          name: mall.mallName
        });
      });
    }
    return list;
  }

  // 기간
  private searchDateType: string = 'REGISTER_YMDT';
  private searchDateTypes = [
    {
      value: 'REGISTER_YMDT',
      name: 'COMMON_REGISTER_YMDT'
    },
    {
      value: 'DISPLAY_YMDT',
      name: 'DISPLAY_POPUP_DISPLAY_YMDT'
    }
  ];
  private startYmd: string = addMonth(new Date(), -3);
  private endYmd: string = getToday();

  // 팝업명
  private keyword: string = '';

  // 초기화
  private reset() {
    this.mallNo = '';
    this.searchDateType = 'REGISTER_YMDT';
    (this.$refs.dateCalendar as any).clickPeriod('3m');
    this.keyword = '';
  }

  // 조회
  private popupsData = null as any;
  private totalCount: number = 0;
  private size: number = 30;
  private contentBottomOption = {
    name: 'pop_list',
    haveConfigBtn: false,
    onLoadSearch: false,
    haveExcelDownBtn: false
  };
  private gridProps = {
    columns: [
      {
        header: 'COMMON_MODIFY',
        name: 'modifyBtnCell',
        align: 'center',
        minWidth: 54,
        renderer: (props) => {
          let rowData = props.grid.getRow(props.rowKey);
          let hrefInfo = {
            linkTo: {
              path: '/popup/add',
              query: {popupNo: rowData.popupNo}
            },
            text: window.$t('COMMON_MODIFY')
          };
          return aHrefRenderer(hrefInfo);
        }
      },
      {
        header: 'COMMON_MALL',
        name: 'mallName',
        align: 'center',
        width: 54
      },
      {
        header: 'DISPLAY_POPUP_HERDER_POPUP_NO',
        name: 'popupNo',
        align: 'center',
        width: 54
      },
      {
        header: 'DISPLAY_POPUP_HERDER_POPUP_NAME',
        name: 'popupName',
        align: 'left',
        width: 124,
        renderer: HtmlEncodeRenderer
      },
      {
        header: 'DISPLAY_POPUP_HERDER_POPUP_SIZE',
        name: 'popupSize',
        align: 'center',
        width: 64,
        copyOptions: {
          useFormattedValue: true
        },
        formatter: (cell: any) => {
          return `${cell.row.popupHeight}x${cell.row.popupWidth}`;
        }
      },
      {
        header: 'DISPLAY_POPUP_HERDER_POPUP_TYPE',
        name: 'popupTypeLabel',
        align: 'center',
        width: 64
      },
      {
        header: 'DISPLAY_POPUP_HERDER_POPUP_DISPLAY_TYPE',
        name: 'popupDisplayType',
        align: 'center',
        width: 124,
        formatter: (cell: any) => {
          if (cell.row.popupDisplayType === 'ALL') {
            return window.$t('COMMON_ALL');
          } else if (cell.row.popupDisplayType === 'CUSTOMIZED') {
            return cell.row.platformDisplayType.map((item: any) => window.$t(`DISPLAY_POPUP_PLATFORM_TYPE_${item}`)).join(', ');
          } else {
            return cell.row.popupDisplayType;
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_POPUP_HERDER_APPLY_PAGE_INFO',
        name: 'applyPageInfo',
        align: 'center',
        width: 254,
        formatter: (cell: any) => {
          return cell.row.applyPageInfoValue.pageTypes.map((item: any) => window.$t(`DISPLAY_POPUP_PAGE_TYPE_${item}`)).join(', ');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_POPUP_HERDER_DISPLAY_YMDT',
        name: 'displayYmdt',
        align: 'center',
        width: 254,
        formatter: (cell: any) => {
          return `${cell.row.displayPeriod.startYmdt} - ${cell.row.displayPeriod.endYmdt}`;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'DISPLAY_POPUP_HERDER_DISPLAY_NO',
        name: 'displayNo',
        align: 'center',
        width: 54
      },
      {
        header: 'DISPLAY_POPUP_HERDER_DISPLAY_YN',
        name: 'displayYn',
        align: 'center',
        width: 124,
        formatter: this.formatterDisplayYn,
        copyOptions: {
          useFormattedValue: false,
          customValue: (value) => {
            return value === 'Y' ? window.$t('DISPLAY_POPUP_DISPLAY_YN_Y') : window.$t('DISPLAY_POPUP_DISPLAY_YN_N');
          }
        }
      },
      {
        header: 'DISPLAY_POPUP_HERDER_ADMIN_NAME',
        name: 'adminName',
        align: 'center',
        width: 54
      },
      {
        header: 'COMMON_REGISTER_YMDT',
        name: 'registerYmdt',
        align: 'center',
        width: 124
      },
      {
        header: 'COMMON_DELETE',
        name: 'deleteBtnCell',
        align: 'center',
        minWidth: 50,
        formatter: (call: any) => {
          let popupname = htmlEncode(call.row.popupName);
          return `<a href="javascript:;" class="deletePopupBtn" data-popupno="${call.row.popupNo}" data-popupname="${popupname}">${window.$t('COMMON_DELETE')}</a>`;
        }
      }
    ],
    header: {
      height: 32
    },
    options: {
      rowHeaders: [
        {
          type: 'rowNum',
          width: 61
        }
      ],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 32,
      rowHeight: 32,
      displayRowCount: 20,
      isInitialRequest: true,
      keyColumnName: 'popupNo',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };
  private formatterDisplayYn(call: any) {
    let displaySelect = `<select data-popupno="${call.row.popupNo}" class="changeDisplayYn" style="width: 100%;">`;
    if (call.value === 'Y') {
      displaySelect += `<option value="Y" selected="selected">${window.$t('DISPLAY_POPUP_DISPLAY_YN_Y')}</option><option value="N">${window.$t('DISPLAY_POPUP_DISPLAY_YN_N')}</option>`;
    } else {
      displaySelect += `<option value="Y">${window.$t('DISPLAY_POPUP_DISPLAY_YN_Y')}</option><option value="N" selected="selected">${window.$t('DISPLAY_POPUP_DISPLAY_YN_N')}</option>`;
    }
    displaySelect += '</select>';
    return displaySelect;
  }
  private async changeDisplayYn(e: any) {
    let popupNo = $(e.target).data('popupno');
    let displayYn = $(e.target).val() as string;
    let request: PutPopupsPopupNoDisplayStatusRequest = {
      pathParams: {
        popupNo: Number(popupNo)
      },
      data: {
        displayYn
      }
    };
    $('#loading').show();
    await this.$api.putPopupsPopupNoDisplayStatus(request);
    $('#loading').hide();
  }
  private async search(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }
    let request: GetPopupsRequest = {
      params: {
        searchDateType: this.searchDateType as DisplayPopupSearchDateType,
        startYmd: this.startYmd,
        endYmd: this.endYmd,
        page,
        size: this.size
      }
    };
    if (this.mallNo !== '') {
      request.params.mallNos = Number(this.mallNo);
    }
    if (this.keyword !== '') {
      request.params.keyword = this.keyword;
    }
    const response = await this.$api.getPopups(request);
    const {data} = response;
    this.popupsData = data.contents;
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }
  private async delPopup(e: any) {
    let popupNo = $(e.target).data('popupno');
    let confirmMsg = `[${popupNo}] ${$(e.target).data('popupname')}, ${window.$t('DISPLAY_POPUP_DEL_MSG')}`;
    if (confirm(confirmMsg)) {
      let request: DeletePopupsRequest = {
        params: {
          popupNos: Number(popupNo)
        }
      };
      await this.$api.deletePopups(request);
      await this.search(1);
    }
  }
  private async excelDown() {
    let request: GetPopupsExcelRequest = {
      params: {
        searchDateType: this.searchDateType as DisplayPopupSearchDateType,
        startYmd: this.startYmd,
        endYmd: this.endYmd
      }
    };
    if (this.mallNo !== '') {
      request.params.mallNos = Number(this.mallNo);
    }
    if (this.keyword !== '') {
      request.params.keyword = this.keyword;
    }
    const {data} = await this.$api.getPopupsExcel(request);
    if (data.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      let keyMapJson = {
        mallName: 'COMMON_MALL',
        popupNo: 'DISPLAY_POPUP_HERDER_POPUP_NO',
        popupName: 'DISPLAY_POPUP_HERDER_POPUP_NAME',
        popupSize: 'DISPLAY_POPUP_SIZE',
        popupType: 'DISPLAY_POPUP_HERDER_POPUP_TYPE',
        platformDisplayType: 'DISPLAY_POPUP_HERDER_POPUP_DISPLAY_TYPE',
        applyPageInfo: 'DISPLAY_POPUP_HERDER_APPLY_PAGE_INFO',
        exposurePeriod: 'DISPLAY_POPUP_HERDER_DISPLAY_YMDT',
        displayNo: 'DISPLAY_POPUP_HERDER_DISPLAY_NO',
        displayable: 'DISPLAY_POPUP_HERDER_DISPLAY_YN',
        adminName: 'DISPLAY_POPUP_HERDER_ADMIN_NAME',
        registerYmdt: 'COMMON_REGISTER_YMDT'
      };
      keyMapJson = i18nAllObject(this, keyMapJson);
      let formatters = {
        exposurePeriod: (cell: any) => {
          return `${cell.row.displayPeriod.startYmdt} - ${cell.row.displayPeriod.endYmdt}`;
        }
      };
      let fileName = `popup_${changeDateFormat(new Date(), 'YYYYMMDD_HHmmss')}`;
      writeExcel(data, keyMapJson, fileName, formatters);
    }
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private async mounted() {
    await this.fetchMalls();
    if (this.malls.length === 1) {
      this.mallNo = this.malls[0].mallNo.toString();
    }
    await this.search(1);
    $('body').on('click', '.deletePopupBtn', $.proxy(this.delPopup, this));
    $('body').on('change', '.changeDisplayYn', $.proxy(this.changeDisplayYn, this));
  }
  private beforeDestroy() {
    $('body').off('click', '.deletePopupBtn');
    $('body').off('change', '.changeDisplayYn');
  }
}
